import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import Lightbox from 'react-images';

const styles = () => ({
  gridList: {
    margin: 0,
    padding: 0,
  },
  photo: {
    cursor: 'pointer'
  }
});

class Gallery extends React.Component {
  state = { currentImage: 0 }

  openLightbox = index => {
    this.setState({
      currentImage: index,
      lightboxIsOpen: true,
    });
  }
  
  closeLightbox = () => {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    });
  }

  gotoPrevious = () => {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }

  gotoNext = () => {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }

  render() {
    const { classes, photos } = this.props;
    const urls = photos.map(photo => ({ src: photo.url }));

    return (
      <React.Fragment>
        <Grid container spacing={1}>
          {photos.map((photo, index) => (
            <Grid item key={index}>
              <a onClick={() => this.openLightbox(index)}>
                <img 
                  src={photo.thumbnailUrl} 
                  alt={photo.fileName} 
                  className={classes.photo}
                  title="Powiększ"
                  style={{height: 130, objectFit: 'cover'}}
                />
              </a>
            </Grid>
          ))}
        </Grid>
        <Lightbox images={urls}
          onClose={this.closeLightbox}
          onClickPrev={this.gotoPrevious}
          onClickNext={this.gotoNext}
          currentImage={this.state.currentImage}
          isOpen={this.state.lightboxIsOpen}
          closeButtonTitle="Zamknij (Esc)"
          imageCountSeparator=" z "
          leftArrowTitle="Poprzednie"
          rightArrowTitle="Następne"
          backdropClosesModal={true}
        />
      </React.Fragment>
    );
  }
}

Gallery.propTypes = {
  classes: PropTypes.object.isRequired,
  photos: PropTypes.array.isRequired,
};

export default withStyles(styles)(Gallery);


// WEBPACK FOOTER //
// ./src/components/consultationSurveys/board/Gallery.js